import React__default from 'react';
import cn from 'classnames';
import { Checkbox } from '../../Checkbox/index.js';
import styles from 'ui-components/FilterMenu/FilterBoolean.scss';

var noop = function noop() {};
var FilterBoolean = function FilterBoolean(_ref) {
  var filter = _ref.filter,
    onValueClick = _ref.onValueClick,
    activeFilters = _ref.activeFilters,
    withinBalanceFilter = _ref.withinBalanceFilter;
  var activeValue = activeFilters && activeFilters.find(function (af) {
    return af.code === filter.code;
  });
  var value = withinBalanceFilter ? withinBalanceFilter : (activeValue == null ? void 0 : activeValue.value) === "1";
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.value, styles.value__boolean),
    onClick: function onClick() {
      return onValueClick({
        code: filter.code,
        value: "1"
      });
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: styles.label
  }, filter.label), /*#__PURE__*/React__default.createElement(Checkbox, {
    className: styles.checkbox,
    value: value,
    onChange: noop
  })));
};

export { FilterBoolean };
//# sourceMappingURL=index.js.map
